import * as React from "react";
import { useEffect } from "react";
import System from "src/helper/system";
import store from "../storeWire";
import { system_notification } from "../store/slice/system";
import $ from "jquery";
import FadeInOut from "../component/FadeInOut";
import AxiosSingletonLoader from "../component/AxiosSingletonLoader";
import { useCartStore } from "src/hooks/cart";
import ShippingAddressPopup from "./Cart/CartModals/ShippingAddressPopup";
import AlertContentWithFlag from "./Checkout/AlertContentWithFlag";
import DOMAttachToSystem from "src/captain/DOMAttachToSystem";
import QuoteCartLeftContent from "./QuoteCart/QuoteCartLeftContent/QuoteCartLeftContent";
import QuoteCartRightContent from "./QuoteCart/QuoteCartRightContent/QuoteCartRightContent";
import useCheckAuthPermissions from "src/hooks/component/useCheckAuthPermissions";
import ReusableDiv from "../support/ReusableDiv";
const c = System.getParams();

export function QuoteCart() {
    const [{ }, { get_is_any_invalid_product, get_cart_quote_number }, { }] = useCartStore();
    const quoteNumber = get_cart_quote_number();
    const isInValid = get_is_any_invalid_product(quoteNumber);
    const [_check_p] = useCheckAuthPermissions();

    const getClassToDisplay = () => {
        return true;
    };

    useEffect(() => {
        if (c.ShippingAddressPopup !== undefined && c.ShippingAddressPopup === "1") {
            store.dispatch(
                system_notification({
                    name: "ShippingAddressPopup",
                    data: [],
                })
            );
            history.pushState(null, null, "?" + $.param(c));
        }
        sessionStorage.setItem("successUrl", "cart")
        sessionStorage.removeItem("invoiceAddress")
    }, []);

    return (
        <>
        {_check_p('QT_CART_VIEW').status && 
            <>
                <ShippingAddressPopup />
                <div className="logged-screen cart-container">
                    <div className="container">
                        <>
                            {process.env.NODE_ENV !== "development" && <DOMAttachToSystem />}
                            {/* <QuoteCartHeader /> */}
                        </>
                        {ReusableDiv.CartDisclaimerMessage()}
                        <FadeInOut show={getClassToDisplay()} duration={100}>
                            {isInValid && (
                                <AlertContentWithFlag type="danger" isDisplay={true} isDisplayIcon={true}
                                    message={
                                        "The part(s) in your cart cannot be shipped to your current <b>shipping country</b>. Please remove them to proceed to Checkout"
                                    }
                                />
                            )}
                            <div className={getClassToDisplay() ? "bs5 row" : ""}>
                                <QuoteCartLeftContent />
                                {getClassToDisplay() && <QuoteCartRightContent />}
                            </div>
                        </FadeInOut>
                        <div className={"bs5 row"}>
                            <AxiosSingletonLoader />
                        </div>
                    </div>
                </div>
            </>
        }
        </>
    );
}
